(function (isNode) {
    var jsSHA = isNode ? require('jssha') : window.jsSHA;

    function numberToHex (number) {
        var hex = Math.round(number).toString(16);
        if(hex.length == 1) {
            hex = '0' + hex;
        }
        return hex;
    }

    var cryptoUtils = {
        toHex: function (arrayOfBytes) {
            var hex = '';
            for(var i = 0; i < arrayOfBytes.length; i++) {
                hex += numberToHex(arrayOfBytes[i]);
            }
            return hex;
        },
        sha256: function (hexString) {
            var sha = new jsSHA(hexString, 'HEX');
            return sha.getHash('SHA-256', 'HEX');
        }
    };

    // export cryptoUtils module
    if(isNode) {
        module.exports = cryptoUtils;
    } else {
        if(typeof window.WAValidator === 'undefined'){
           window.WAValidator = {__imports: {}};
        }
        window.WAValidator.__imports.cryptoUtils = cryptoUtils;
    }
})(typeof module !== 'undefined' && typeof module.exports !== 'undefined');


//////////////////
// WEBPACK FOOTER
// ./~/wallet-address-validator/src/crypto_utils.js
// module id = 891
// module chunks = 0